const FAQ_HEADER_SELECTOR = '.faq-title';

const bindFaqEvents = (root = document) => {
  root.querySelectorAll(FAQ_HEADER_SELECTOR).forEach((header) => {
    if (header.dataset.faqBound === 'true') return;

    const content = header.nextElementSibling;
    const buttonEl = header.querySelector('.faq-button');
    if (!content || !buttonEl) return;

    header.dataset.faqBound = 'true';
    header.addEventListener('click', () => {
      const isExpanded = buttonEl.getAttribute('aria-expanded') === 'true';
      buttonEl.setAttribute('aria-expanded', String(!isExpanded));
      content.toggleAttribute('hidden');
    });
  });
};

const initFaqSection = (scope = document) => bindFaqEvents(scope);

const startFaqObserver = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.(FAQ_HEADER_SELECTOR) || node.querySelector?.(FAQ_HEADER_SELECTOR)) {
          bindFaqEvents(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

const runInitialFaq = () => {
  initFaqSection();
  startFaqObserver();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInitialFaq);
} else {
  runInitialFaq();
}

document.addEventListener('shopify:section:load', (event) => {
  initFaqSection(event.target);
});
